
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/business/event-management",
      function () {
        return require("private-next-pages/[lang]/business/event-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/business/event-management"])
      });
    }
  